import { createSlice } from "@reduxjs/toolkit";
import { HIDE_MODAL_ASSETGROUP, HIDE_MODAL_SELECT_ITEM, HIDE_MODAL_SELECT_STORE, SHOW_MODAL_ASSETGROUP, SHOW_MODAL_SELECT_ITEM, SHOW_MODAL_SELECT_STORE } from "../type";

const initialState = {
    AttendanceRequestData: {},
    LeavesRequestData: {},
    AttendanceHistoryData: {},
    LeaveHistoryData: {},
    WeekoffSubordinateData: {},
    RegisterAssetDataPurchase: {},
    RegisterAssetDataStore: {},
    RegisterAssetGetQRCode: {},
    RegisterAssetRegisteredDownloadData: {},
    SelectedIncrement: {},
    SelectedDecrement: {},
    AgreementDraftData: {},
    UploadfileObjectId: [],
    SelectedUploadFiles: [],
    AgreementUploaded: {},
    IssuedStoreDataDownloadQr: {},
    GetQRByIssuedStore: {},
    shoModalAssetGroup: false,
    showModalSlectItem: false,
    showModalSlectStore: true,
    SelectedStoreData: {},
    SelectedAssetInfoDeRegister: {},
    DeRegisterAssetList: [],
    GetOtpDeRegiaterAsset: {},
    CheckIsiOSDevice: {},
    PurchasedData: [],
}

const attendanceConfigSlice = createSlice({
    name: "attendanceConfigSlice",
    initialState,
    reducers: {
        saveAttendanceRequestData: (state, action) => {
            return { ...state, AttendanceRequestData: action.payload }
        },
        saveLeavesRequestData: (state, action) => {
            return { ...state, LeavesRequestData: action.payload }
        },
        saveAttendanceHistoryData: (state, action) => {
            return { ...state, AttendanceHistoryData: action.payload }
        },
        saveLeaveHistoryData: (state, action) => {
            return { ...state, LeaveHistoryData: action.payload }
        },
        saveWeekoffSubordinateData: (state, action) => {
            return { ...state, WeekoffSubordinateData: action.payload }
        },
        saveRegisterAssetData: (state, action) => {
            return { ...state, RegisterAssetDataPurchase: action.payload }
        },
        saveRegisterAssetStoreData: (state, action) => {
            return { ...state, RegisterAssetDataStore: action.payload }
        },
        saveRegisterAssetGetQRCode: (state, action) => {
            return { ...state, RegisterAssetGetQRCode: action.payload }
        },
        saveReggisterAssetRegisteredDownloadData: (state, action) => {
            return { ...state, RegisterAssetRegisteredDownloadData: action.payload }
        },
        saveSelectedIncrementData: (state, action) => {
            const selectItemUpdateData = state?.RegisterAssetDataPurchase.map((item) => {
                if (item.purchaseId == action?.payload?.purchaseId) {
                    return { ...item, count: item.count + 1 }
                }
                return item;
            })
            return { ...state, RegisterAssetDataPurchase: selectItemUpdateData }
        },
        saveSelectedDecrementData: (state, action) => {
            const selectItemUpdateData = state?.RegisterAssetDataPurchase.map((item) => {
                if (item.purchaseId == action?.payload?.purchaseId) {
                    return { ...item, count: item.count - 1 }
                }
                return item;
            })
            return { ...state, RegisterAssetDataPurchase: selectItemUpdateData }
        },
        saveIsCheckedData: (state, action) => {
            const selectItemUpdateData = state?.RegisterAssetDataPurchase.map((item) => {
                if (item.purchaseId == action?.payload?.purchaseId) {
                    return { ...item, checked: !item.checked, count: 1 }
                }
                return item;
            })
            return { ...state, RegisterAssetDataPurchase: selectItemUpdateData }
        },
        saveIsFilterCheckedData: (state, action) => {
            const selectItemUpdateData = state?.RegisterAssetDataPurchase?.filter((item) => item?.type == action?.payload?.type)
            return { ...state, RegisterAssetDataPurchase: selectItemUpdateData }
        },
        saveAgreementDraftDataData: (state, action) => {
            return { ...state, AgreementDraftData: action?.payload }
        },
        saveAgreemnetUploadfileObjectId: (state, action) => {
            return { ...state, UploadfileObjectId: [...state?.UploadfileObjectId, action.payload] }
        },
        saveAgreementSelectedUploadFiles: (state, action) => {
            const data = { name: action?.payload?.file?.name, randomId: action?.payload?.randomId }
            return { ...state, SelectedUploadFiles: [...state?.SelectedUploadFiles, data] }
        },
        saveAgreementUploadedFiles: (state, action) => {
            return { ...state, AgreementUploaded: action.payload }
        },
        saveIssuedStoreDataDownloadQr: (state, action) => {
            return { ...state, IssuedStoreDataDownloadQr: action?.payload }
        },
        saveGetQRByIssuedStore: (state, action) => {
            return { ...state, GetQRByIssuedStore: action.payload }
        },
        saveModalAssetgroup: (state, action) => {
            switch (action.payload.type) {
                case SHOW_MODAL_ASSETGROUP:
                    return { ...state, shoModalAssetGroup: true };
                case HIDE_MODAL_ASSETGROUP:
                    return { ...state, shoModalAssetGroup: false };
                default:
                    return state
            }
        },
        saveModalSelectItem: (state, action) => {
            switch (action.payload.type) {
                case SHOW_MODAL_SELECT_ITEM:
                    return { ...state, showModalSlectItem: true };
                case HIDE_MODAL_SELECT_ITEM:
                    return { ...state, showModalSlectItem: false };
                default:
                    return state
            }
        },
        saveModalSelectStore: (state, action) => {
            switch (action.payload.type) {
                case SHOW_MODAL_SELECT_STORE:
                    return { ...state, showModalSlectStore: false };
                case HIDE_MODAL_SELECT_STORE:
                    return { ...state, showModalSlectStore: false };
                default:
                    return state
            }
        },
        saveIsCheckedDataDownloadQR: (state, action) => {
            const selectItemUpdateData = state?.IssuedStoreDataDownloadQr?.map((item) => {
                if (item.id == action?.payload?.id) {
                    return { ...item, checked: !item?.checked }
                }
                return item;
            })
            return { ...state, IssuedStoreDataDownloadQr: selectItemUpdateData }
        },
        saveIsCheckedAllItemsDataDownloadQR: (state, action) => {
            const selectItemUpdateData = state?.IssuedStoreDataDownloadQr?.map((item) => {
                if (item.checked == true) {
                    return { ...item, checked: false }
                }
                if (item.checked == false) {
                    return { ...item, checked: true }
                }
            })
            return { ...state, IssuedStoreDataDownloadQr: selectItemUpdateData }
        },
        saveSetSelectData: (state, action) => {
            const selectedStoreData = state.RegisterAssetDataStore?.filter((item) => item?.code == action?.payload?.code)
            return { ...state, SelectedStoreDatas: selectedStoreData }
        },

        saveSelectedAssetInfo: (state, action) => {
            if (state?.IssuedStoreDataDownloadQr && state?.IssuedStoreDataDownloadQr.length) {
                const selectedAssetInfo = state?.IssuedStoreDataDownloadQr?.filter((item) => item?.id == action?.payload?.SelectedAssetId)
                return { ...state, SelectedAssetInfoDeRegister: selectedAssetInfo }
            }
        },
        saveFilteredDeRegisterAssetData: (state, action) => {
            if (state?.IssuedStoreDataDownloadQr && state?.IssuedStoreDataDownloadQr.length) {
                const selectedAssetInfo = state?.IssuedStoreDataDownloadQr?.map((item) => {
                    if (item?.id == action?.payload?.SelectedAssetId) {
                        return { ...item, isSelected: true }
                    }
                    return item;
                })
                return { ...state, IssuedStoreDataDownloadQr: selectedAssetInfo }
            }
        },
        deleteFilteredDeRegisterAssetData: (state, action) => {
            if (state?.IssuedStoreDataDownloadQr && state?.IssuedStoreDataDownloadQr.length) {
                const selectedAssetInfo = state?.IssuedStoreDataDownloadQr?.map((item) => {
                    if (item?.id == action?.payload?.SelectedAssetId) {
                        return { ...item, isSelected: false }
                    }
                    return item;
                })
                return { ...state, IssuedStoreDataDownloadQr: selectedAssetInfo }
            }
        },
        deRegisterAssetList: (state, action) => {
            return { ...state, DeRegisterAssetList: [...state?.DeRegisterAssetList, ...action?.payload] }
        },
        clearDeRegisterState: (state, action) => {
            return { ...state, DeRegisterAssetList: [] }
        },

        deletedeRegisterAssetList: (state, action) => {
            const filterData = state?.DeRegisterAssetList?.filter((item) => item?.id !== action?.payload).map((item) => ({ ...item, isSelected: false }))
            return { ...state, DeRegisterAssetList: filterData }
        },
        getOtpDeRegisterAsset: (state, action) => {
            if (action?.payload) {
                return { ...state, GetOtpDeRegiaterAsset: action?.payload }
            }
        },

        checkIsIosDevice: (state, action) => {
            return { ...state, CheckIsiOSDevice: action.payload }
        },
        saveAddEffectiveDateData: (state, action) => {
            const selectedAssetInfo = state?.IssuedStoreDataDownloadQr?.map((item) => {
                if (item?.id == action?.payload?.Id) {
                    return { ...item, AddEffectiveDate: action?.payload?.Date }
                }
                return item;
            })
            return { ...state, IssuedStoreDataDownloadQr: selectedAssetInfo }
        },
        saveClearEffectiveDateData: (state, action) => {
            const selectedAssetInfo = state?.IssuedStoreDataDownloadQr?.map((item) => {
                if (item?.id == action?.payload) {
                    return { ...item, AddEffectiveDate: '' }
                }
                return item;
            })
            return { ...state, IssuedStoreDataDownloadQr: selectedAssetInfo }
        },
        savePurchasedData: (state, action) => {
            return { ...state, PurchasedData: [...state?.PurchasedData, ...action?.payload] };
        },

    },
});

export const { savePurchasedData, saveClearEffectiveDateData, saveAddEffectiveDateData, checkIsIosDevice, deleteFilteredDeRegisterAssetData, clearDeRegisterState, saveFilteredDeRegisterAssetData, getOtpDeRegisterAsset, deletedeRegisterAssetList, deRegisterAssetList, saveSelectedAssetInfo, saveModalSelectStore, saveSetSelectData, saveModalSelectItem, saveModalAssetgroup, saveIsCheckedAllItemsDataDownloadQR, saveIsCheckedDataDownloadQR, saveGetQRByIssuedStore, saveIssuedStoreDataDownloadQr, saveAgreementUploadedFiles, saveAgreementSelectedUploadFiles, saveAgreemnetUploadfileObjectId, saveIsFilterCheckedData, saveIsCheckedData, saveAgreementDraftDataData, saveSelectedDecrementData, saveSelectedIncrementData, saveReggisterAssetRegisteredDownloadData, saveRegisterAssetGetQRCode, saveAttendanceRequestData, saveLeavesRequestData, saveAttendanceHistoryData, saveLeaveHistoryData, saveWeekoffSubordinateData, saveRegisterAssetData, saveRegisterAssetStoreData } = attendanceConfigSlice.actions;
export default attendanceConfigSlice.reducer;
